import { RouterView } from "vue-router";
import { ProfileRouting } from "./profile/profile.routing";
import { ChangeRouting } from "./change/change.routing";
import { VisaRouting } from "./visa/visa.routing";
import { InvoiceRouting } from "./invoice/invoice.routing";
import { ManageRouting } from "./manage/manage.routing";

// TODO: 合同模块中, 需要读取当前登录用户作为默认申请人
// 读取当前租户, 作为默认单位

export const ContractRouting = {
  path: "/contract",
  name: "contract",
  redirect: "/contract/profile/list",
  component: RouterView,
  meta: { title: "合同管理", icon: "gongcheng" },
  children: [...ProfileRouting, ...ChangeRouting, ...VisaRouting, ...InvoiceRouting, ...ManageRouting],
};
